import { createSSRApp } from 'vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import pinia from '@/stores/store';
import mitt from 'mitt';
import App from './App.vue';
import router from './router';
window.wx = undefined;

export function createApp() {
    const app = createSSRApp(App);

    // 引入事件驱动
    app.config.globalProperties.$evtBus = mitt();

    // 引入路由库
    app.use(router);

    // 引入pinia全局状态库
    app.use(pinia.use(piniaPluginPersistedstate));

    return {
        app
    };
}
